import { Box, MenuItem, Stack, Typography } from "@mui/material"
import { useDialog } from "lib/@hooks/useDialog"
import { NameDialog } from "lib/@dialogs/nameDialog"
import Iconify from "minimals-template/components/Iconify"
import { useBoundValue } from "lib/@components/binding/use-bound-value"
import { useBoundContext } from "lib/@components/binding/use-bound-context"

export const FIXED_VALUE_OPTION = "_fixedValueOption"

export function FixedValueOption({ searchText, closeMenu, onSelect, ...props }) {
    const {
        required,
        selectedOption,
        item: { field, allowFixedValue = true },
    } = useBoundContext()
    const [fixedMapping, setFixedMapping] = useBoundValue("fields." + field + "_fixed")

    const fixedValueDialog = useDialog(<NameDialog title={"Input a Fixed Value"} message value={fixedMapping} />)

    const showFixedValue =
        allowFixedValue && (!searchText || fixedMapping?.toLowerCase().includes(searchText.toLowerCase()))

    if (required) return null

    return (
        showFixedValue && [
            <MenuItem
                key="fixed-value-option"
                disableRipple
                divider
                sx={{ py: 0.4 }}
                {...props}
                value={FIXED_VALUE_OPTION}
                onClick={handleOpenDialog}
                data-cy="fixed-value-option"
            >
                <Stack direction="row" alignItems="center" sx={{ width: 1, height: "40px" }}>
                    <Box width={24} component="span" sx={{ lineHeight: 0 }}>
                        {selectedOption !== "" && selectedOption === fixedMapping && (
                            <Iconify sx={{ color: "primary.main" }} icon="mdi:check" />
                        )}
                    </Box>

                    <Stack sx={{ justifyContent: "space-between", width: 1, alignItems: "center" }} direction="row">
                        <Typography
                            variant="body2"
                            sx={{ textOverflow: "ellipsis", maxWidth: 450, overflow: "hidden" }}
                        >
                            <strong>{fixedMapping ?? "Input a fixed value"}</strong>
                        </Typography>

                        {fixedMapping && (
                            <Typography variant="caption" fontStyle="italic" color="text.secondary" align="right">
                                Fixed value
                            </Typography>
                        )}
                    </Stack>
                </Stack>
            </MenuItem>,

            // Hidden item to make MUI happy
            fixedMapping && (
                <MenuItem key="fixed-value-option-hidden" value={fixedMapping} style={{ display: "none" }}>
                    {fixedMapping}
                </MenuItem>
            ),
        ]
    )

    async function handleOpenDialog() {
        closeMenu()
        setTimeout(async () => {
            const fixedValue = await fixedValueDialog()
            if (fixedValue) {
                setFixedMapping(fixedValue)
                onSelect(FIXED_VALUE_OPTION)
            }
        }, 150)
    }
}
